import { useState } from "react";
import { useLang } from "../i18n/LanguageContext";
import { TRANSFORMATIONS } from "../config";
import { Reveal, Page } from "../components/Reveal";
import PageHero from "../components/PageHero";
import Lightbox from "../components/Lightbox";
import BeforeAfterSlider from "../components/BeforeAfterSlider";
import SEO from "../components/SEO";

const Transformacoes = () => {
  const { t } = useLang();
  const [filter, setFilter] = useState("all");
  const [lightbox, setLightbox] = useState(null);

  const filters = ["all", "antesDepois", "coloracao", "balayage", "progressiva", "cortes"];
  const items = TRANSFORMATIONS.filter((i) => filter === "all" || i.cats.includes(filter)).map((i) => ({
    ...i,
    caption: t.transformationsPage.captions[i.key],
  }));
  const singles = items.filter((i) => !i.pair);

  return (
    <Page>
      <SEO title={t.meta.transformacoes.title} desc={t.meta.transformacoes.desc} />
      <PageHero eyebrow={t.transformationsPage.eyebrow} title={t.transformationsPage.title} desc={t.transformationsPage.p} testid="transformations-hero" />

      <section className="bg-cream pb-24 sm:pb-32" data-testid="transformations-gallery">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <div className="mb-12 flex flex-wrap gap-2.5" role="tablist" aria-label="Filtros">
            {filters.map((f) => (
              <button
                key={f}
                role="tab"
                aria-selected={filter === f}
                data-testid={`filter-${f}`}
                onClick={() => { setFilter(f); setLightbox(null); }}
                className={`rounded-full px-5 py-2.5 text-[11px] font-bold uppercase tracking-[0.16em] transition-all duration-300 ${
                  filter === f
                    ? "bg-rosedeep text-white shadow-lg"
                    : "border border-blush bg-white text-ink/60 hover:border-rose/60 hover:text-ink"
                }`}
              >
                {t.transformationsPage.filters[f]}
              </button>
            ))}
          </div>

          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {items.map((item, i) => (
              <Reveal key={`${item.key}-${i}`} delay={(i % 3) * 0.08}>
                {item.pair ? (
                  <figure>
                    <BeforeAfterSlider
                      before={item.pair[0]}
                      after={item.pair[1]}
                      alt={item.caption}
                      labels={t.transformationsPage.slider}
                      testid={`transformation-${item.key}-${i}`}
                    />
                    <figcaption className="mt-3 text-center font-serif text-lg italic text-rosedeep">
                      {item.caption}
                    </figcaption>
                  </figure>
                ) : (
                  <button
                    onClick={() => setLightbox(singles.indexOf(item))}
                    data-testid={`transformation-${item.key}-${i}`}
                    className="img-zoom card-lift group relative block w-full overflow-hidden rounded-3xl text-left ring-1 ring-blush transition-shadow hover:ring-rose/50"
                  >
                    <img src={item.img} alt={item.caption} className="aspect-[4/5] w-full object-cover" loading="lazy" />
                    <div className="absolute inset-0 flex items-end bg-gradient-to-t from-ink/60 via-transparent to-transparent p-6 opacity-0 transition-opacity duration-500 group-hover:opacity-100">
                      <span className="font-serif text-lg italic text-white">{item.caption}</span>
                    </div>
                  </button>
                )}
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <Lightbox
        items={singles}
        index={lightbox}
        onClose={() => setLightbox(null)}
        onNav={(dir) => singles.length > 0 && setLightbox((i) => (i + dir + singles.length) % singles.length)}
      />
    </Page>
  );
};

export default Transformacoes;
